import React from "react";
import TotalScore from "../../components/TotalScore";

const LogoAndTotalScorePdf = ({ dish }) => {

  return (
    <div className="relative w-full flex justify-between items-center pb-3">
      <div className="px-4 pb-2" style={{ transform: "translateY(10px)" }}>
        <img
          className="w-1/2"
          src={`${process.env.PUBLIC_URL}/assets/images/consupedia_logo_blue.svg`}
          alt="Consupedia Logo"
        />
      </div>
      <div className="flex justify-end items-center gap-4 pr-4">
        <TotalScore dish={dish} />
      </div>
    </div>
  );
};

export default LogoAndTotalScorePdf;